class ExitConfirmationPopup {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.overlay = wrapper.querySelector('.popup-message-overlay');
    this.closeButton = wrapper.querySelector('.popup-message-close');
    this.cancelButton = wrapper.querySelector('.exit-cancel-button');
    this.confirmButton = wrapper.querySelector('.exit-confirm-button');
    this.container = wrapper.querySelector('.popup-message-container');
    
    this.targetDomain = wrapper.dataset.targetDomain.replace(/^https?:\/\//, '') || 'chipotle.com';
    
    this.pendingUrl = null;
    
    this.init();
  }


  init() {
    this.setupEventListeners();
    this.interceptLinks();
  }

  interceptLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      
      if (!link) return;
      
      const href = link.getAttribute('href');
      
      if (href && this.shouldInterceptLink(href)) {
        e.preventDefault();
        e.stopPropagation();
        this.pendingUrl = href;
        this.show();
      }
    }, true);
  }

  shouldInterceptLink(href) {
    const url = new URL(href, window.location.origin);
    
    let linkHostname = url.hostname.toLowerCase();
    linkHostname = linkHostname.replace(/^www\./, '');
    
    return linkHostname === this.targetDomain || linkHostname.includes(this.targetDomain);
  }

  show() {
    this.wrapper.classList.add('active');
    document.body.classList.add('popup-open');
    
    this.wrapper.offsetHeight;
    
    requestAnimationFrame(() => {
      this.wrapper.classList.add('visible');
    });

    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.focus();
      } else {
        this.closeButton.focus();
      }
    }, 300);

    this.announceToScreenReader('Exit confirmation displayed');
  }

  hide() {
    this.wrapper.classList.remove('visible');
    
    setTimeout(() => {
      this.wrapper.classList.remove('active');
      document.body.classList.remove('popup-open');
      this.pendingUrl = null;
    }, 300);

    this.announceToScreenReader('Exit confirmation closed');
  }

  confirm() {
    if (this.pendingUrl) {
      window.location.href = this.pendingUrl;
    }
  }

  setupEventListeners() {
    this.closeButton.addEventListener('click', () => {
      this.hide();
    });

    if (this.cancelButton) {
      this.cancelButton.addEventListener('click', () => {
        this.hide();
      });
    }

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => {
        this.confirm();
      });
    }

    this.overlay.addEventListener('click', () => {
      this.hide();
    });

  }


  announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.classList.add('visually-hidden');
    announcement.textContent = message;
    document.body.appendChild(announcement);
    
    setTimeout(() => {
      announcement.remove();
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const exitPopupWrapper = document.querySelector('.exit-confirmation-wrapper');
  if (exitPopupWrapper) {
    new ExitConfirmationPopup(exitPopupWrapper);
  }
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const wrapper = event.target.querySelector('.exit-confirmation-wrapper');
    if (wrapper) {
      new ExitConfirmationPopup(wrapper);
    }
  });
}
